import React from "react";
import Alert from "@mui/material/Alert";
import AlertTitle from "@mui/material/AlertTitle";
import Button from "@mui/material/Button";

const SharedAccountNotice = ({ onRegister }) => (
  <Alert
    severity="info"
    sx={{ mb: 3 }}
    action={
      // nowrap: длинная подпись иначе ломается на три строки и растягивает
      // блок по высоте — MUI даёт action-колонке ровно остаток ширины.
      <Button
        color="inherit"
        size="small"
        onClick={onRegister}
        sx={{ whiteSpace: "nowrap", alignSelf: "center" }}
      >
        Создать личный аккаунт
      </Button>
    }
  >
    <AlertTitle>Вы работаете под общим аккаунтом</AlertTitle>
    Ключ, выпущенный сейчас, будет общим для всех: по журналу не понять, чей
    агент им ходил, а отзыв ударит по всем сразу. Личный аккаунт заводится за
    минуту и получает те же права.
  </Alert>
);

export default SharedAccountNotice;
